<template>
  <div class="cardviewer">
    <!--CardViewer-->
        <div v-if="isLoading">Loading card...</div>
        <div v-else>
          <template>
            <v-card>
              <v-container fluid class="ma-0 cardviewer">
                <v-row justify="center" align="center">
                  <v-col cols="auto">
                    <v-img
                      class="cardimg"
                      :src="card.image"
                    ></v-img>
                  </v-col>

                  <v-col>
                    <v-col :justify="cardjustify">
                      <v-row>
                        <h2 class="text-h2">{{ card.name }}</h2> <span v-html="generateCastingCostImages(card.castingCost)"></span>
                      </v-row>
                      <v-row>
                        <span v-html="generateSetImage(card.setCode)"></span><h5 class="text-h5">#{{ card.number }}</h5>
                      </v-row>
                      <v-row>
                        <v-col>
                          <p class="text-xl-body-1">{{ card.text }}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        {{ card.flavorText }}
                      </v-row>
                      <v-row>
                        <CardScroll />
                      </v-row>
                    </v-col>
                  </v-col>
                </v-row>

                <v-row>
                  <v-row
                    class="flex-column fill-height"
                    :justify="cardjustify"
                    :align="cardalign"
                  >
                    <v-col
                      cols="auto"
                      class="text-center"
                    >
                      <!-- TODO: Implement actions
                      <v-card-actions>
                        <v-row class="flex-column ma-0">
                          <v-col class="px-0">
                            <v-btn icon>
                              <v-icon>mdi-heart</v-icon>
                            </v-btn>
                            <v-btn icon>
                              <v-icon>mdi-bookmark</v-icon>
                            </v-btn>
                            <v-btn icon>
                              <v-icon>mdi-share-variant</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    -->
                    </v-col>
                  </v-row>
                </v-row>
                  <v-col>
                    <Commenter />
                  </v-col>
                <v-row>
                </v-row>
              </v-container>
            </v-card>
          </template>
        </div>
    </div>
</template>

<script>
import Commenter from './Commenter'
import CardScroll from './CardScroll'
// import axios from 'axios'
import store from '../store'
// import { API_BASE_URL } from '../config'

export default {
    name: 'App',
    metaInfo: {
      title: 'ParleyMTG',
      titleTemplate: '%s | ParleyMTG'
    },
    components: {
      Commenter,
      CardScroll
    },
    data() {
        return {
            isLoading: true,
            players: {},
            cardjustify: 'end',
            cardalign: 'end',
            card: {}
        }
    },
    async created () {
        // Subscribe to changes in the selected card
        this.unsubscribe = store.subscribe((mutation) => {
          if (mutation.type === 'updateSelectedCard') {
            this.card = store.state.selectedCard
            console.log('card here')
            console.log(this.card)
            this.isLoading = false
          }
        })

        if (this.$route.query.card != null) {
            store.dispatch('selectCard', {"cardId": this.$route.query.card})
        }
    },
    methods: {
      generateCastingCostImages: function (castingCost) {
        castingCost = castingCost.replace('/', '')
        castingCost = castingCost.replace(/[{]/g,'<img src="/images/casting/')
        castingCost = castingCost.replace(/[}]/g,'.svg" class="castingCostDisplay">')
        return castingCost
      },
      generateSetImage: function (setCode) {
        setCode = '<img src="/images/sets/' + setCode.toLowerCase() + '.svg">'
        return setCode
      }
    }
}
</script>
